import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb } from '../../shared/components/breadcrumb/Breadcrumb';
import { Page } from '../../layout';
import { OrganizationList } from './shared/components/OrganizationList';
import ApolloError from '../../shared/components/ApolloError';
import { useOrganizationSearch } from '../hooks/useOrganizationSearch';

const EXECUTIVE_SUMMARY_URL = '/data-reports/organization-reports/executive-summary';
const PAGE_TITLE = 'Organization Search';

const ExecutiveSummaryOrganizationSearch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPageURL = location.pathname;

  const breadcrumbPathItems = [
    { name: 'Data Reports', url: '/data-reports' },
    { name: 'Organization Reports', url: '/data-reports/organization-reports' },
    { name: 'Executive Summary', url: currentPageURL },
    { name: 'Organization Search', url: '' }
  ];

  const { organizations, totalCount, loading, error, searchState } = useOrganizationSearch();

  const handleSelectOrganization = orgId => {
    navigate(`${EXECUTIVE_SUMMARY_URL}/${orgId}`);
  };

  if (error) {
    return <ApolloError />;
  }

  return (
    <Page title={PAGE_TITLE}>
      <Breadcrumb pathItems={breadcrumbPathItems} />
      <OrganizationList
        shouldShowSearchControls={true}
        onSelectOrganization={handleSelectOrganization}
        organizations={organizations}
        totalCount={totalCount}
        loading={loading}
        searchTextPlaceholder='Search by Name'
        searchState={searchState}
      />
    </Page>
  );
};

export default ExecutiveSummaryOrganizationSearch;
